export default __webpack_public_path__ + "static/ABCMonumentGrotesk-Regular-2d87075ebcfac4818ea6d1ae37d7f132.woff";